module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2i"
  }, [_c('a', {
    attrs: {
      "id": "ch04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 4")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg",
      "width": "150px"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2title"
  }, [_vm._v("Teaching, Training, Teamwork")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _vm._v(" surprise awaited Lt. Col. Charles Hunter at Deolali in the formidable shape of Col. Francis G. Brink, General Staff Corps. A former light-heavyweight boxing champion at Cornell University, Brink had worked for the American Embassy in Tokyo before the outbreak of war. Hunter admired Brink’s “can-do” attitude but found him a little too “secretive” on certain subjects. He was also ")]), _c('a', {
    attrs: {
      "id": "prolog53"
    }
  }, [_vm._v("“puzzled” to discover that Brink had been appointed the 1688th Detachment’s training officer, a role Hunter had more than adequately fulfilled during their voyage to India.")])]), _c('a', {
    attrs: {
      "id": "prolog53"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hunter remained responsible for discipline and administration, but he was troubled by the division of leadership. He suspected that were it not for the fact that Brink was a member of the General Staff Corps—and thereby ineligible by military law to exercise command of troops—he would have replaced him as the detachment’s commander.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog53"
    }
  }, [_vm._v("Hunter’s common sense and good fellowship made for a generally happy camp in Deolali. Hunter respected that the men had all volunteered, and while his standards were high he treated them as adults. As a commander, he was hard but fair, authoritarian but approachable. There was just one line that could never be crossed. ")]), _c('a', {
    attrs: {
      "id": "prolog54"
    }
  }, [_vm._v("“I don’t want to see anyone taking sunbaths,” he informed the men. “I don’t know why it should be, but I’ve found that people who take sunbaths are difficult to get along with.”")])]), _c('a', {
    attrs: {
      "id": "prolog54"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog54"
    }
  }, [_vm._v("Thanks in no small part to Hunter’s approach in Deolali, the sinews of the volunteers were strengthened by an "), _c('em', [_vm._v("esprit de corps")]), _vm._v(". ")]), _c('a', {
    attrs: {
      "id": "prolog55"
    }
  }, [_vm._v("“This period of relative inactivity and freedom did a lot for the physical and mental outlook of the men,” said Capt. James Hopkins. “I do not recall any criminal activity, ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("significant complaining, or fights among the men or with the natives. The minimal classroom-like training and organized marches were completed with good humor.”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the first visitors to the detachment’s camp was Maj. Gen. Orde Wingate, an event that aroused much curiosity among the men. Here at last was the fabled guerrilla fighter, the scourge of the Japanese, the man labeled a “genius” by none other than Winston Churchill.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even by the eccentric standards of the British officer class, Wingate was a maverick. In Burma, the pious forty-year-old rarely went anywhere without a fly gun, and it was his custom to tie an alarm clock to his person so he wouldn’t be late for appointments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wingate’s reputation as a guerrilla fighter had been forged in the British Mandate of Palestine in the late 1930s; there he had raised a unit of counter-insurgency troops, Night Squads, to protect oil pipelines from sabotage by Arab fighters. He was eventually posted back to Britain when his commanders grew concerned that Wingate was fighting more for the Jewish cause than to protect British interests in Palestine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the outbreak of the Second World War in September 1939, Wingate was sent to Ethiopia, where he deployed similar guerrilla tactics to those used in Palestine in helping the army of Emperor Haile Selassie defeat Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A period of depression followed for Wingate, culminating in an attempt to kill himself in a Cairo hotel in July 1941. But he returned to England, recuperated, and then set off for Burma in 1942 with orders to organize a guerrilla campaign against the Japanese.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Ted McLogan was struck by Wingate’s size—")]), _c('a', {
    attrs: {
      "id": "prolog56"
    }
  }, [_vm._v("“he only stood about five foot five inches with a great beard”—while Bernard Martin found him “nice and easy to talk to” after he was required by Wingate to send a couple of radio messages back to his headquarters in Jhansi.")])]), _c('a', {
    attrs: {
      "id": "prolog56"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At Brink’s behest, Wingate addressed the officers of the 1688th Detachment in the mess hall, a lecture that was well received by some and less so by others.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog56"
    }
  }, [_vm._v("Captain Fred Lyons of the 2nd Battalion listened wide-eyed with amazement as Wingate ")]), _c('a', {
    attrs: {
      "id": "prolog57"
    }
  }, [_vm._v("“told us every detail of his famous Raider campaign in Burma the year before so we could profit by his experience and come out of the jungle alive.” Lyons, who had yet to see combat, gobbled up every morsel of information thrown his way by Wingate. “I see him now,” he recalled, “his hawk-like face animated as he warned us never to speak above a whisper in the jungle, never to try to pull away a blood-sucking leech, never to drink jungle water without sterilizing it.”")])]), _c('a', {
    attrs: {
      "id": "prolog57"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog57"
    }
  }, [_vm._v("Lieutenant Sam Wilson was “aware of his innovativeness” but was somewhat surprised by his size and the high pitch of his voice. ")]), _c('a', {
    attrs: {
      "id": "prolog58"
    }
  }, [_vm._v("“He was rather Messianic,” said Wilson. “He reminded me a little bit of a fundamentalist ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("preacher at a revival. He would get kind of worked up. He was obviously a brilliant man, but also a very strange man.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Captain James Hopkins was less impressed with what he heard from Wingate. A veteran of Guadalcanal and a skilled surgeon, Hopkins stared in disbelief when the British general declared emphatically that ")]), _c('a', {
    attrs: {
      "id": "prolog59"
    }
  }, [_vm._v("“dysentery can be controlled by the wearing of a tight band about the waist.”")])]), _c('a', {
    attrs: {
      "id": "prolog59"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog59"
    }
  }, [_vm._v("Not all of Wingate’s advice was nonsensical. He recommended the use of heavy machine guns in the jungle as an effective means of inflicting casualties on an enemy close at hand but concealed by the dense undergrowth. He also reassured his American allies that in all his time in the jungle, he had yet to come face to face with a man-eating tiger. Elephants, yes, but not tigers. As for the jungle itself, Wingate said there was no need to fear it. It was large and deep, like a placid ocean, but with a map and compass it was just as navigable. In fact, from a junior leader’s standpoint, the jungle offered far more opportunity to display individual initiative and responsibility than any other theater of war. The crucial point, stressed Wingate, was that the ")]), _c('a', {
    attrs: {
      "id": "prolog60"
    }
  }, [_vm._v("“best defence in the jungle is to seek out the enemy and attack him, and thus impose your will on him … therefore what are needed are self-reliant, alert-minded officers and men who will act with vigor according to the situation confronting them.”")])]), _c('a', {
    attrs: {
      "id": "prolog60"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unbeknown to Wingate, as he expounded his theories on jungle warfare to the 1688th Detachment, a storm was brewing with Gen. Joseph Stilwell at its epicenter. As well as being the deputy commander of South East Asia Command, Stilwell was also commander of Americans in the China Burma India Theater and chief of staff to Chiang Kai-shek. It still rankled Stilwell that the first American force of ground troops earmarked for operations in Burma had been placed under British control. He vowed to wrest their command from Wingate.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog60"
    }
  }, [_vm._v("Stilwell was especially cantankerous in the second week of November 1943, so much so that in his diary he took out his anger on President Roosevelt by referring to him as ")]), _c('a', {
    attrs: {
      "id": "prolog61"
    }
  }, [_vm._v("“Rubberlegs,” a grievous mockery of his leader’s polio. Stilwell believed that the president was being weak in his dealings with Chiang Kai-shek over Chinese military assistance.")])]), _c('a', {
    attrs: {
      "id": "prolog61"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Stilwell already had in mind a large-scale operation for Burma, a plan he conceived “as a jerk to the sleeves of his allies that could not be ignored.” What the general envisaged was a three-phase advance into northern Burma, the main attack coming from two Chinese divisions and the 1688th Detachment—but only if they were under his direct command.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog61"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Stilwell planned that this force would march south from India into Burma along the Ledo Road and then push into the jungle, advancing through the Hukawng and Mogaung valleys to capture the airstrip at Myitkyina, the strategic jewel in northern Burma.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Stilwell took his plan to the Cairo Conference, which was billed as the largest gathering of its kind with “all the British and American officers of whom one had ever heard.” Winston Churchill was present, as was Roosevelt, and when Stilwell arrived in the Egyptian capital on November 20, he had among his entourage Col. Frank Merrill.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("*")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("On the same day that Stilwell arrived in Cairo to discuss plans for an offensive in Burma, the 1688th Detachment completed its move from Deolali to a new base. The seven-hundred-mile journey northeast to the Jahklann station in Bengal Province took three days. Once the force (each battalion traveled separately twenty-four hours apart) alighted from the train, they were obliged to march ten miles ")]), _c('a', {
    attrs: {
      "id": "prolog62"
    }
  }, [_vm._v("“across dry, rugged land, irregularly covered with spine-producing bushes about six feet high,” recalled Capt. Thomas Bogardus.")])]), _c('a', {
    attrs: {
      "id": "prolog62"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog62"
    }
  }, [_vm._v("Their new home was Camp Deogarh, a former British military establishment approximately eighty miles to the south of Wingate’s Chindits at Jhansi. The camp was not electrified, and there was no running water or telephone system. Everyone, officers and men, was billeted in tents. “A tent city consisting of British cotton tents,” was how Bogardus described Deogarh. ")]), _c('a', {
    attrs: {
      "id": "prolog63"
    }
  }, [_vm._v("“They were double-layered to keep the heat down in the midday sun of India—extremely cold at night but very hot in the daytime.”")])]), _c('a', {
    attrs: {
      "id": "prolog63"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Each battalion was allocated its own section of the camp where its men slept, ate, and trained, independent of the other two battalions. It was an arrangement that concerned Colonel Brink, who believed that the 1688th Detachment would prosper if the combat-experienced soldiers of the 3rd Battalion were divided up among the other two battalions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hunter opposed the idea, advising Brink not to tamper with the camaraderie that was taking root in the unit. But Brink went ahead and transferred 6 officers and 160 men from the 3rd Battalion into the 1st and 2nd battalions.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog63"
    }
  }, [_vm._v("Private First Class Gabriel Kinney, the iron ore miner from Alabama, was torn from the bosom of the buddies he had fought alongside in Guadalcanal. ")]), _c('a', {
    attrs: {
      "id": "prolog64"
    }
  }, [_vm._v("“My reaction to being transferred was total disappointment,” he reflected. “There were five of us volunteers from F Company, 35th Regiment, 25th Division. When we left Vella Lavella, we thought we would stay together.”")])]), _c('a', {
    attrs: {
      "id": "prolog64"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog64"
    }
  }, [_vm._v("If the transfer was difficult for 3rd Battalion personnel, it also raised issues among the 2nd Battalion. Kinney was now the sole combat veteran ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("in the 1st Platoon of E Company, 2nd Battalion, under the command of Lt. Larry Lindgren. “Other than being totally yellow because of the [atabrine] pills, I was the one the other members of the platoon asked questions about combat,” said Kinney. “That didn’t stand me in good stead with Lindgren.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Kinney now had to answer the same questions that he himself had asked combat veterans on Guadalcanal when he had arrived on the island in December 1942 to relieve the 1st Marine Division. ")]), _c('a', {
    attrs: {
      "id": "prolog65"
    }
  }, [_vm._v("“The answer I gave was the one I’d been told: ‘If you’re still alive in the morning, you know what you’re doing is right.’”")])]), _c('a', {
    attrs: {
      "id": "prolog65"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the six officers uprooted was Lt. Ted McLogan, moved to the Green Combat Team of the 2nd Battalion, a comeuppance he said he deserved for “lording it over the other two [battalions] because they hadn’t had combat.” Transferred into McLogan’s platoon from the 3rd Battalion was Sgt. Ed Kohler. “After a few days with these men, I knew we had our work cut out for us,” he recalled.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog65"
    }
  }, [_vm._v("McLogan accepted his fate with equanimity and became acquainted with his new commanding officer, the taciturn Lt. Col. George Alexander McGee. McGee was from Denver, a West Pointer from the Class of 1937 whose yearbook photograph depicted a neat, dark-haired young man, handsome yet intense. ")]), _c('a', {
    attrs: {
      "id": "prolog66"
    }
  }, [_vm._v("“Plebe year was safely passed before we saw him smile,” ran his yearbook biography. “But now his own ready wit makes life more enjoyable for all.”")])]), _c('a', {
    attrs: {
      "id": "prolog66"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maggie,” as McGee was known to his fellow West Pointers, wore chevrons in an exemplary manner; enjoyed poetry, music, and lacrosse; and longed to own a horse and a dog. “A hard worker, he enjoys working for experience’s sake,” continued the yearbook. “Graduation will embark him on a career for which his preparation is complete, a career in which his fine qualities will ensure him continued success away from these walls.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the outbreak of war, McGee was commanding officer of the 2nd Battalion, 33rd Infantry Regiment, recently returned from Fort Clayton in the Panama Canal Zone. Within days of Pearl Harbor, the regiment was ordered to Trinidad to protect the newly acquired Lend-Lease bases on the Caribbean island. For more than eighteen months, they remained on the island until the day, to McGee’s unbridled relief, he was ordered to find volunteers for a unit code named “Galahad.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog66"
    }
  }, [_vm._v("One of the first officers summoned to McGee’s office was Capt. Fred Lyons. ")]), _c('a', {
    attrs: {
      "id": "prolog67"
    }
  }, [_vm._v("“‘Do you want to volunteer for a dangerous and hazardous secret mission in an active theater?’ he asked me,” remembered Lyons. “A dangerous and hazardous secret mission! My heart gave a jump. But wasn’t this what I’d been waiting for? ‘Sure as hell,’ I replied, ‘When do we start?’ Colonel McGee asked the same question of all the officers and men in the regiment, and everyone gave the same answer.”")])]), _c('a', {
    attrs: {
      "id": "prolog67"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog67"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Lyons was accepted by McGee, as were captains Henry Stelling, one of the 33rd’s medical officers, and Thomas Bogardus, who recalled that more than one thousand soldiers volunteered so that McGee had the luxury of deciding which men to select and which to omit.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("The soldiers selected by McGee were soon on their way to the States. ")]), _c('a', {
    attrs: {
      "id": "prolog68"
    }
  }, [_vm._v("“Our Trinidad unit boarded every available plane that landed there and was flown to Miami as quickly as possible,” recalled T5 George Rose, who hailed from Emporia, Virginia. Rose had quit his job in a furniture store to enlist underage in the 33rd Infantry. Now he was in Florida, with the sense of excitement mounting. ")]), _c('a', {
    attrs: {
      "id": "prolog69"
    }
  }, [_vm._v("“Men who had volunteered for the mission were pouring into the hotels; cavalry men from Jamaica, engineers from Puerto Rico, riflemen from Panama, radio experts from Washington. They were all confined to their hotels and were not allowed even to walk around the streets or telephone home. Nobody knew anything about where we were going or what we were to do.”")])]), _c('a', {
    attrs: {
      "id": "prolog69"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the experience of the 3rd Battalion now running like a seam through the unit, Colonel Brink divided each battalion into two jungle columns, as advised by General Wingate, a man Brink admired greatly. Nevertheless, Brink decided not to ape the British in calling them “columns” but instead designating them “combat teams.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each of the six combat teams was color-coded and each trained to operate as a self-contained unit, comprising a heavy weapons platoon, a rifle company, an intelligence and reconnaissance (I&R) platoon, a communications platoon, and a pioneer and demolitions detachment (see table on page 37).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lieutenant Colonel William Osborne was assigned command of the 1st Battalion, with its Red and White combat teams under the command of Major Edward Ghiz and Major Caifson Johnson, respectively. The 2nd Battalion, led by McGee, comprised the Blue Combat Team under Major Richard Healy and the Green Combat Team under Captain Thomas Bogardus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lieutenant Colonel Charles Beach, a thirty-five-year-old from Cincinnati nicknamed “Old Ranger,” commanded the 3rd Battalion. Major Lawrence Lew led the Orange Combat Team, and Major Edwin Briggs was in command of the Khaki Combat Team.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog69"
    }
  }), _c('a', {
    attrs: {
      "id": "prolog70"
    }
  }, [_vm._v("“Colonel Beach was a nice guy,” recalled Bernard Martin, who was in the communications platoon attached to the Orange Combat Team. “A courageous and straightforward man, he wasn’t afraid of anything. He would never hide behind his rank.”")])]), _c('a', {
    attrs: {
      "id": "prolog70"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog70"
    }
  }, [_vm._v("By now, the 3rd Battalion had been renamed the “Chow Raiders” because of their constant assaults on the camp’s kitchens, a moniker that the men ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("recognized with their own battalion insignia pinned to their lapels—the small can openers that came with 10-in-1 ration packs.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("While Hunter busied himself with administrative tasks at Deogarh, Brink oversaw the detachment’s training. He was careful not to step on the toes of the three battalion commanders, and his tact was appreciated by Lieutenant Colonel McGee, who praised the “wide latitude” afforded by his approach and the way he ")]), _c('a', {
    attrs: {
      "id": "prolog71"
    }
  }, [_vm._v("“rarely if ever convened the battalion commanders, instead he visited them individually and observed training frequently, and in a soft-spoken but firm manner made suggestions and otherwise provided guidance.”")])]), _c('a', {
    attrs: {
      "id": "prolog71"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The training was punishing, conducted in countryside that reminded Thomas Bogardus of the photographs he’d seen of central Africa. “Brush and scrub and fair to middling high grasses,” he recounted. Aside from the hours spent on the firing range, the men practiced ambushes, casualty evacuation, trailing, and trail concealment. They launched attacks against enemy pillboxes, learned how to receive an airdrop, and mastered the art of crossing a river in the shortest time possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The M1919 Browning machine gunners were encouraged to fire as much ammunition as they wanted. There was too much ammunition of all caliber in Deogarh to be taken to Burma, so it was expended in the scrubland around the camp. In addition, soldiers were taught how to fire every type of weapon, from a Browning Automatic Rifle to a semi-automatic M1 Garand rifle to a Thompson submachine gun and carbine. The idea, wrote Hunter, was “that when the chips were down they could employ them collectively to create a sledge hammer effect to crush the heretofore ‘Banzai’ charge of the hysterical, hopped-up Asians.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Different men preferred different weapons. As a sergeant, Roy Matsumoto had been given a Garand, but he found its 4.3 kilograms too heavy so he traded it for a carbine, which was two kilograms lighter. Bernard Martin and Robert Passanisi, though both radio operators, would be infantrymen just like everyone else on the march through the jungle. The pair preferred the Garand, Martin because it was easy to clean and Passanisi because of its accuracy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog71"
    }
  }, [_vm._v("Other skills were honed in the scrubland around Deogarh, such as how to handle a hand grenade. The green troops were told to forget what they’d learned in training about using two hands to remove a pin from a grenade. That could be fatal in combat. Never take your eyes off the enemy, not even for a couple of seconds to locate and squeeze the pin that would release the spoon (or handle). Instead, as T5 Robert Passanisi recalled, they were taught to ")]), _c('a', {
    attrs: {
      "id": "prolog72"
    }
  }, [_vm._v("“squeeze the pin most of the way, then place the ring over one of your fatigue buttons and then button the button. When the situation called for a grenade, all you had to do was reach over with one hand, without looking. Grab the grenade and spoon, like you would a baseball, then with a sharp tug ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("pull the grenade free, leaving the ring and cotter pin still on the button, and never taking your eyes off the action.”")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("The communication platoons held classes in which the men familiarized themselves with their radio equipment (which arrived in December). This consisted of AN/PRC-1s and SCR (Signal Corps Radio) 284s, as well as SCR 300s, portable radio transceivers worn on a mounted backpack and better known as walkie-talkies. “The SR300 was a tremendous asset,” remembered Passanisi. “It weighed about sixty-five pounds with a thirty-pound battery and with eighteen tubes. It was state-of-the-art.” The SCR 284, a combination transmitter and receiver with a hand crank generator, was far more cumbersome. Passanisi considered it ")]), _c('a', {
    attrs: {
      "id": "prolog73"
    }
  }, [_vm._v("“very inefficient compared to the others and very hard to generate power.”")])]), _c('a', {
    attrs: {
      "id": "prolog73"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Each battalion also had its own medical detachment, composed of five doctors and approximately thirty medics of varying abilities. Their role would be of paramount importance, for in Burma disease was an enemy far more prevalent and inestimably more merciless than the Japanese. In 1943, the British and Indian troops were a hundred times more likely to be struck down by illness than they were an enemy bullet.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog73"
    }
  }, [_vm._v("Technician Fourth Grade Richard Murch was a medical surgical assistant and anesthetist in Red Combat Team, 1st Battalion. ")]), _c('a', {
    attrs: {
      "id": "prolog74"
    }
  }, [_vm._v("“Physical disability, incompetence, etc., during our training in Deogarh thinned the ranks of the NCOs,” he recalled. Murch gained an extra stripe as a result of this depletion of the battalion’s medical staff, rising in rank to Tech 3.")])]), _c('a', {
    attrs: {
      "id": "prolog74"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog74"
    }
  }, [_vm._v("While at Deogarh, the 1688th Detachment carried out several training exercises with Wingate’s Chindits, themselves preparing for a second mission to Burma. ")]), _c('a', {
    attrs: {
      "id": "prolog75"
    }
  }, [_vm._v("“The Chindits were really tough guys; they put us through our paces,” recalled Bernard Martin. “We went on these long marches with fifty pounds on our back, and sometimes in the middle of the night they would start firing their weapons, shouting, ‘We’re the enemy, we’re the enemy.’ Other times, they would just burst into our tents and throw a bucket of cold water over our faces, and we had to react. They taught us well and trained us well.”")])]), _c('a', {
    attrs: {
      "id": "prolog75"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog75"
    }
  }, [_vm._v("Lieutenant Sam Wilson also found the time spent with the Chindits instructive. ")]), _c('a', {
    attrs: {
      "id": "prolog76"
    }
  }, [_vm._v("“They were much leaner, more conservative, in what they carried and in what kinds of external support they expected,” he reflected. “We were sort of, by nature, a little spoiled … you can do more with less, and you really don’t need most of the things you think you do.” Wingate called the tendency of soldiers to carry a surfeit of nonessential items into combat “Christmas treeing”; it was an aversion he bequeathed to the officers of the 1688th Detachment.")])]), _c('a', {
    attrs: {
      "id": "prolog76"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog76"
    }
  }, [_vm._v("Wilson was selected by Lieutenant Colonel Osborne to lead the 1st Battalion’s intelligence and reconnaissance platoon, a singular honor given his age. Chosen to command the 2nd Battalion’s I&R platoon was 1st Lt. ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("William Grissom, a man described by one of his soldiers as a ")]), _c('a', {
    attrs: {
      "id": "prolog77"
    }
  }, [_vm._v("“a fine officer and well respected by his men.”")])]), _c('a', {
    attrs: {
      "id": "prolog77"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog77"
    }
  }, [_vm._v("Logan Weston held a similar standing among the 3rd Battalion’s I&R platoon, one of whom, Sgt. Alfred Freer, described their officer as ")]), _c('a', {
    attrs: {
      "id": "prolog78"
    }
  }, [_vm._v("“a tall, lanky, soft-spoken man [who] did not act like the typical officer. He wasted few words.”")])]), _c('a', {
    attrs: {
      "id": "prolog78"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Nearly two hundred soldiers applied to join Weston’s outfit (which was soon affectionately rechristened the “Ignorant & Rugged” platoon). Knowing he could only select fifty-four men, Weston meticulously screened all candidates, looking for those who had distinguished themselves in the South Pacific and further whittling down the list by recruiting soldiers who “had trusted the Lord to deliver them under combat situations.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The men selected for the I&R platoons had to be tough, alert, and supremely fit. Their task once operations started would be to “snoop” several miles ahead of their battalion, reconnoitering the dense jungle not only for the enemy but for routes of march, bivouac camps, and suitable areas for airdrops.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog78"
    }
  }, [_vm._v("Conscious of what General Wingate had said about the need for self-reliant, alert-minded officers and men able to take the initiative, Lt. Sam Wilson instigated a set of standard operating procedures (SOPs) for hand signals with little verbal communication. “I was a little nutty on things like that,” he recalled. ")]), _c('a', {
    attrs: {
      "id": "prolog79"
    }
  }, [_vm._v("“If you come under fire, or something is going wrong, you flash a signal and at least you execute something quickly and in a well-organized fashion. If you can explode in the face of an enemy in that way when he thinks he’s got you in an ambush, you can come at him so hard that he doesn’t know what has hit him.”")])]), _c('a', {
    attrs: {
      "id": "prolog79"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Wilson saw parallels between his I&R platoon and a football team, in that certain plays are developed and practiced over and over until everyone “can do them in their sleep,” even when wounded or frightened.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By the middle of December, Hunter was concerned by the lack of official recognition accorded the 1688th Detachment by South East Asia Command. Neither its supreme commander, British vice-admiral Lord Louis Mountbatten (a cousin of King George VI), nor his deputy, General Stilwell, had acknowledged their presence in the region, and save for the visit from Wingate, they might not have existed. Worse, the force hadn’t even been given a name or an insignia that could be invested with pride.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog79"
    }
  }, [_vm._v("Hunter ")]), _c('a', {
    attrs: {
      "id": "prolog80"
    }
  }, [_vm._v("“began to put pressure on the Rear Echelon Headquarters of CBI to do something about the situation,” he recalled, but with little success. He wasn’t alone in feeling a sense of mounting frustration at the ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("pace of events in the CBI Theater. The Cairo Conference hadn’t gone well for Stilwell, and Chiang Kai-shek—whom the American referred to in private as “Peanut”—was being more capricious than ever, one moment agreeing to commit large numbers of Chinese troops to an offensive in Burma, the next day withdrawing his consent.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Matters reached a head on November 25, 1943, when President Roosevelt informed Stilwell that Chiang had accepted SEAC’s plan for a Burmese campaign. In the evening, he was summoned back to the president’s residence to be told that the generalissimo had had second thoughts. ")]), _c('a', {
    attrs: {
      "id": "prolog81"
    }
  }, [_vm._v("“Louis [Mountbatten] is fed up on Peanut,” wrote Stilwell in his diary. “As who is not?”")])]), _c('a', {
    attrs: {
      "id": "prolog81"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog81"
    }
  }, [_vm._v("Stilwell could at least derive a measure of satisfaction from the knowledge that Churchill and Roosevelt had seen firsthand in Cairo what Chiang was like, what he had had to endure for more than a year. ")]), _c('a', {
    attrs: {
      "id": "prolog82"
    }
  }, [_vm._v("“They have been driven absolutely mad,” was how Mountbatten described the reactions of the two great Western leaders.")])]), _c('a', {
    attrs: {
      "id": "prolog82"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Nonetheless, a declaration was signed at Cairo, made public on December 1, in which Britain and the United States recognized China as a great power and promised the return “of all the territories Japan has stolen from the Chinese.” In addition, the Allies agreed to an amphibious assault on the Andaman Islands off the southern Burmese coast, an operation Chiang believed would divert Japanese troops from the mainland and make the land invasion easier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four days after the promulgation of the declaration, the amphibious assault was abandoned when the Americans and British agreed that logistically it wouldn’t be possible to spare so many landing craft so close to the invasion of France.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roosevelt telegrammed the decision to Chiang, also inquiring whether he was prepared to still support a land offensive in northern Burma or wait a year when the Allies would be better able to launch a major amphibious landing in Southeast Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chiang was furious with what he saw as another Western betrayal, but he played the abandonment of the operation to his advantage. Yes, he would still support a land offensive, but only in return for more financial support from the United States. While the Chinese and American governments argued over the exact nature of the monetary aid, Stilwell began preparing to invade northern Burma.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog82"
    }
  }, [_vm._v("On December 18, Chiang agreed that Stilwell would command the 22nd and 28th Chinese divisions assembling on the border between Assam and Burma, making it the first time an American would lead Chinese soldiers into battle. “It took a long time, but apparently confidence has been established,” Stilwell wrote in his diary. ")]), _c('a', {
    attrs: {
      "id": "prolog83"
    }
  }, [_vm._v("“If the bastards will only fight, we can make a dent in the Japs.”")])]), _c('a', {
    attrs: {
      "id": "prolog83"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog83"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Stilwell’s plan, code named “Capital,” called for a three-pronged attack; the Chinese Y (Yoke) Force would cross from China into northeast Burma, fording the Salween River and attacking the Japanese around Lungling, and the British IVth Corps would strike in the west across the Chindwin. Meanwhile, his two divisions would drive down the middle of northern Burma and seize Myitkyina while supported by Colonel Hunter’s 1688th Detachment. They would be confronted by the Japanese 18th Division, regarded as one of the outstanding divisions in the Japanese army under the command of General Shinichi Tanaka, conqueror of Singapore.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("On December 24 the offensive began, watched by Stilwell from his Burmese headquarters at Shingbwiyang. Wearing a steel helmet instead of his usual battered felt infantry campaign hat, Stilwell braved sniper fire to encourage the 38th Division as they advanced into the Yubang Ga. In the first week of fighting, the Chinese lost 750 men killed or wounded, but they forced the Japanese to fall back, a direction they had seldom gone since their occupation of Burma.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Emboldened by the initial gains of the Chinese, Stilwell now turned his attention to finally gaining control of the only American infantry unit then on the Asian continent—the 1688th Detachment.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("*")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("General Stilwell, nicknamed “Vinegar Joe” early in his military career, found much of humanity objectionable, but he hated the British more than most. As a chief intelligence officer for the IV Corps in France during the First World War, Stilwell was attached to the British 58th Division in France. It was a chastening experience for a young officer trying to make his way in the world. The British were ")]), _c('a', {
    attrs: {
      "id": "prolog84"
    }
  }, [_vm._v("“so damn snotty,” with their condescending attitude gnawing at Stilwell’s innate insecurity.")])]), _c('a', {
    attrs: {
      "id": "prolog84"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Now in the CBI Theater, where he was commanding general of the United States Army Forces, Stilwell believed the British were guilty of docility. “Yellow Limeys,” he called his Allies in his diary, an opinion only marginally tempered by Orde Wingate’s Chindit expedition into Burma in February 1943.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog84"
    }
  }, [_vm._v("Since the Cairo Conference, Stilwell had agitated for the transfer of the 1688th Detachment to his command, and finally at a conference in Delhi on December 31 he got his way, as an exasperated Mountbatten declared: ")]), _c('a', {
    attrs: {
      "id": "prolog85"
    }
  }, [_vm._v("“For God’s sake, take them off my hands.”")])]), _c('a', {
    attrs: {
      "id": "prolog85"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Undoubtedly, Stilwell’s relationship with General Marshall had contributed to the latter’s decision. The more Marshall observed Wingate’s methods, the greater his concern that American lives would be squandered by the ruthless British general.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog85"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("It fell to Lieutenant Colonel Hunter and Col. Francis Brink, both of whom were present at the Delhi Conference, to inform Wingate that he was no longer in charge of the 1688th Detachment. It was a task neither relished.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Hunter and Brink located the Chindits’ leader at the airport as he prepared to board a flight to Jhansi. ")]), _c('a', {
    attrs: {
      "id": "prolog86"
    }
  }, [_vm._v("“Wingate greeted us affably,” recalled Hunter, and then Brink informed him that the 1688th Detachment was now under the command of Stilwell. “With this Wingate’s piercing black eyes clouded with anger and he blurted out, ‘Brink, you tell General Stilwell he can take his Americans and stick ’em up his ass.’”")])]), _c('a', {
    attrs: {
      "id": "prolog86"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog86"
    }
  }, [_vm._v("Wingate’s pique was understandable; in losing the 1688th Detachment he had also lost face, but the ethos that he believed underpinned long-range penetration had also been compromised by the decision to transfer command of the American force. “Ignorance is our main weakness,” Wingate had written in his report of the first Chindits mission. ")]), _c('a', {
    attrs: {
      "id": "prolog87"
    }
  }, [_vm._v("“Long Range Penetration will prove a dismal failure unless it is conducted from one centre, with one plan, one doctrine, one training and one control in the field.”")])]), _c('a', {
    attrs: {
      "id": "prolog87"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Wingate’s anger was fueled by a fear that in decentralizing command of the LRP, South East Asia Command had made a grave mistake that would have serious repercussions in Burma.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brink soon had his own reason to curse Stilwell. Within days, he was unceremoniously relieved of his position as the detachment’s training officer. “Vinegar Joe” was living up to his nickname.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722da8a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 84
// module chunks = 0